/**
 * Adapter: delegates IAudioPort to services/audioService.
 */
import {
  initAudio,
  playSfx,
  startAmbientNoise,
  stopAmbientNoise,
  setVolumes,
  type SoundType,
} from '../../../services/audioService';
import type { IAudioPort } from '../../domain/ports/IAudioPort';

export class AudioServiceAdapter implements IAudioPort {
  initAudio(): AudioContext {
    return initAudio();
  }

  playSfx(type: SoundType): void {
    playSfx(type);
  }

  startAmbientNoise(): void {
    startAmbientNoise();
  }

  stopAmbientNoise(): void {
    stopAmbientNoise();
  }

  setVolumes(master: number, sfx: number, ambient: number): void {
    setVolumes(master, sfx, ambient);
  }
}